module.exports = __webpack_public_path__ + "static/media/Report_Graphic.b6b26bbe.png";